import { initializeApp } from "firebase/app";
import { browserLocalPersistence, connectAuthEmulator, getAuth, setPersistence } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

/**
 * The portal's own domain serves Firebase's auth handler at /__/auth, so when
 * the page is on it the sign-in popup and redirect stay first-party. Safari
 * blocks the third-party storage the default firebaseapp.com handler needs.
 * The domain must be listed under Authentication, Authorised domains, and on
 * the Google OAuth client (docs/COACHING_README.md).
 */
export const PORTAL_DOMAIN = "coach.swana.co.uk";
const onPortalDomain = typeof window !== "undefined" && window.location.hostname === PORTAL_DOMAIN;

// The same public web config the mobile app ships; it identifies the project, it is not a secret.
const app = initializeApp({
    apiKey: "AIzaSyBU8u9n01BOOkIcwF5jcFJvpC6QPUIG4xI",
    authDomain: onPortalDomain ? PORTAL_DOMAIN : "matchcam-10b3d.firebaseapp.com",
    projectId: "matchcam-10b3d",
    storageBucket: "matchcam-10b3d.firebasestorage.app",
    messagingSenderId: "85735656743",
    appId: "1:85735656743:web:92ca5c6f90a3bc288ded02",
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west2");

// DEV only: Vite reads .env.local for production builds too, so the flag on its own
// could ship a portal pointed at the emulators.
export const usingEmulators = import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "1";
if (usingEmulators) {
    const host = import.meta.env.VITE_EMULATOR_HOST ?? "127.0.0.1";
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8080);
    connectFunctionsEmulator(functions, host, 5001);
}

void setPersistence(auth, browserLocalPersistence);
